import Vue from 'vue'

export const formatDateFilter = (date, showTime = true) => {
	if (date) {
		if (!showTime) {
			return Vue.moment(date).format('DD/MM/YYYY')
		} else {
			return Vue.moment(date).format('DD/MM/YYYY HH:mm')
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/filters/formatDate.js